import type { Containers } from '@/domain/useCases/navBar/constants'
import { isNonEmptyArray } from '@/utils/checks'
import React, { memo } from 'react'
import { ChevronUp, ChevronDown, ChevronRight } from 'react-bootstrap-icons'

interface NavLinksProps {
  items
  label: string
  toggleOpen: (label: string) => void
  currentlyOpen: string
  setPage: (page: string) => void
  setContainer: (container: Containers | string) => void
}

export const NavLinks = ({
  items,
  label,
  toggleOpen,
  currentlyOpen,
  setPage,
  setContainer
}: NavLinksProps): JSX.Element => {
  const open = currentlyOpen == label

  return (
    <menu
      className="relative size-full"
      aria-label={`${label} menu`}
    >
      <li
        className={`flex flex-col items-start justify-between border-b border-gray-300 text-lg font-normal
            text-gray-1100 ${open ? 'pb-8' : 'pb-0'}`}
      >
        <div
          className="mb-4 flex h-14 w-full cursor-pointer items-center justify-between text-xl font-medium text-gray-1100"
          aria-label={`Browse treatment by ${label}`}
          onClick={() => {
            toggleOpen(label)
          }}
        >
          {label}
          <span>
            {open ? (
              <ChevronUp className="size-6 text-gray-1100" />
            ) : (
              <ChevronDown className="size-6 text-gray-1100" />
            )}
          </span>
        </div>
        {open && items && (
          <div className="text-lg font-medium leading-7">
            <ul className="flex flex-col gap-4">
              {items.map(
                (item: {
                  label: string
                  container: Containers
                  page: string
                }) => (
                  <li
                    key={item.label}
                    aria-label={`Browse by ${item.label}`}
                    className="text-gray-800"
                  >
                    <div
                      onClick={() => {
                        setPage(item.page)
                        setContainer(item.container)
                      }}
                      className="inline-flex text-gray-800 decoration-gray-800"
                    >
                      {item.label}
                      <span className="flex items-center pl-2">
                        <ChevronRight className="size-4 text-gray-1100" />
                      </span>
                    </div>
                  </li>
                )
              )}
            </ul>
          </div>
        )}
      </li>
    </menu>
  )
}
export default memo(NavLinks)
